<template>
  <Modal
      :title="$t('front.crucial_updates_title')"
      @close="reload"
  >
    {{ $t('front.crucial_updates') }}

    <span class="fw-medium">{{ $t('front.page_will_automatically_reload') }} {{ time }} {{ $t('front.second_short') }}</span>

    <div class="d-flex justify-content-center align-items-center mt-5">
      <Button
          @click="reload"
          class="btn-primary"
      >
        {{ $t('global.reload') }}
      </Button>
    </div>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import Button from "@/js/Elements/Button.vue";
import {useLoader} from "@/js/Plugins/Loader.js";
import {ref} from "vue";

const loader = useLoader();
let timer = null;
const time = ref(6);

updateTime();

function updateTime() {
  time.value -= 1;

  if (time.value < 1) {
    return reload();
  }
  timer = setTimeout(updateTime, 1000);
}

function reload() {
  clearTimeout(timer);
  loader.show();
  window.location.reload();
}
</script>